import { apiFetch } from "@/lib/api";

/** Shared display fields for labor operator avatar stacks. */
export interface LaborOperatorDisplay {
  userId: string;
  email: string;
  fullName: string | null;
  avatarUrl: string | null;
}

export const LABOR_STATION_PRESENCE_INTERVAL_MS = 15_000;

export const ACTIVE_STATION_OPERATOR_PAGES = [
  "final-qc",
  "pre-encapsulation",
  "encapsulation",
  "wireless-check",
  "cal+test",
  "shipping-team",
  "receiving",
] as const;

export type ActiveStationOperatorPage = (typeof ACTIVE_STATION_OPERATOR_PAGES)[number];

export const RECEIVING_PRESENCE_FLOORS = ["arrivals", "receive", "holding", "to-stock"] as const;

export type ReceivingPresenceFloor = (typeof RECEIVING_PRESENCE_FLOORS)[number];

export function activeStationOperatorsQueryKey(
  page: ActiveStationOperatorPage,
  receivingFloor?: ReceivingPresenceFloor,
) {
  return ["labor", "active-station-operators", page, receivingFloor ?? "all"] as const;
}

export async function fetchActiveStationOperators(
  page: ActiveStationOperatorPage,
  receivingFloor?: ReceivingPresenceFloor,
): Promise<LaborOperatorDisplay[]> {
  const data = await apiFetch<{ operators: LaborOperatorDisplay[] }>("/api/labor/active-station-operators", {
    query: receivingFloor != null ? { page, receiving_floor: receivingFloor } : { page },
    cache: "no-store",
  });
  return data.operators;
}
